import { Component } from "react";
import PropTypes from "prop-types";
import { anchorProductToUrl } from "../../state/modules/search/productTile/actions";
import { connect } from "react-redux";
import { getShowDiscountLabel } from "../../state/modules/featureToggles/selectors";
import { withTranslation } from "../translation";
import styles from "./index.css";
import getDiscount from "./getDiscount";
import getAriaLabel from "./getAriaLabel";
import ProductDescription from "./ProductDescription";
import ProductDiscount from "./ProductDiscount";
import ProductPrice from "../../containers/ProductTile/ProductPrice";
import SaveForLater from "./SaveForLater";

const getProductTileId = id => `product-${id}`;

export class ProductTile extends Component {
  constructor(props) {
    super(props);

    if (props.focusOnMount) {
      this.anchorElement = null;
      this.setAnchorElementRef = element => {
        this.anchorElement = element;
      };
      this.focusAnchorElement = () => {
        if (this.anchorElement) {
          this.anchorElement.focus();
        }
      };
    }
  }

  onClick = () => {
    const { id, pageNumber, anchorProductToUrl } = this.props;
    anchorProductToUrl({ productTileId: getProductTileId(id), pageNumber });
  };

  componentDidMount() {
    if (this.focusAnchorElement) {
      this.focusAnchorElement();
    }
  }

  render() {
    const {
      id,
      url,
      image,
      price,
      isSale,
      isOutlet,
      badgeType,
      productType,
      description,
      colourWayId,
      reducedPrice,
      formatCurrency,
      formatTranslation,
      hasMultiplePrices,
      discountLabelEnabled,
      ProductImageComponent
    } = this.props;

    const formattedPrice = formatCurrency(price);

    let formattedReducedPrice = null,
      discount = null;
    if (reducedPrice) {
      formattedReducedPrice = formatCurrency(reducedPrice);
      if (discountLabelEnabled) {
        discount = getDiscount({ oldPrice: price, newPrice: reducedPrice });
      }
    }

    return (
      <article
        id={getProductTileId(id)}
        data-auto-id="productTile"
        className={styles.productTile}
      >
        <a
          ref={this.setAnchorElementRef}
          className={styles.productLink}
          href={url}
          aria-label={getAriaLabel({
            description,
            price: formattedPrice,
            reducedPrice: formattedReducedPrice,
            isOutlet,
            discount,
            badgeType,
            hasMultiplePrices,
            formatTranslation
          })}
          onClick={this.onClick}
        >
          <ProductImageComponent src={image} badgeType={badgeType} />
          <ProductDescription text={description} />
          <ProductPrice
            price={formattedPrice}
            isSale={isSale}
            isOutlet={isOutlet}
            reducedPrice={formattedReducedPrice}
            hasMultiplePrices={hasMultiplePrices}
          />
          {discount !== null && <ProductDiscount discount={discount} />}
        </a>
        {productType !== "MixMatchGroup" && (
          <SaveForLater productId={id} colourWayId={colourWayId} />
        )}
      </article>
    );
  }
}

ProductTile.propTypes = {
  isSale: PropTypes.bool,
  isOutlet: PropTypes.bool,
  pageNumber: PropTypes.number,
  reducedPrice: PropTypes.number,
  id: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  hasMultiplePrices: PropTypes.bool,
  image: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  discountLabelEnabled: PropTypes.bool,
  description: PropTypes.string.isRequired,
  colourWayId: PropTypes.number.isRequired,
  formatCurrency: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  anchorProductToUrl: PropTypes.func.isRequired,
  badgeType: PropTypes.oneOf(["MixMatch", "MoreColors"]),
  productType: PropTypes.string.isRequired,
  focusOnMount: PropTypes.bool.isRequired,
  ProductImageComponent: PropTypes.any.isRequired
};

ProductTile.defaultProps = {
  badgeType: null,
  isSale: false,
  isOutlet: false,
  hasMultiplePrices: false,
  focusOnMount: false
};

ProductTile.displayName = "ProductTile";

const mapStateToProps = state => ({
  discountLabelEnabled: getShowDiscountLabel(state)
});

const mapDispatchToProps = {
  anchorProductToUrl
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(ProductTile));
